import ApiService from "@/core/services/ApiService";

class MasterService {

    public static Details(source: string, target:string) {
        ApiService.setHeader()
        return ApiService.get(`${source}/catalogue`,target)
    }

}

export default MasterService;